<template>
  <svg :width="width"
       :height="height"
       role="presentation"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       @click="$emit('click')">
    <path d="M15.2563 16.9497C12.5463 19.6834 8.15273 19.6834 5.44269 16.9497C2.73265 14.216 2.73265 9.78403 5.44269 7.0503C8.15273 4.31657 12.5463 4.31657 15.2563 7.0503" :stroke="disabled ? disabledStateColor : iconColor" stroke-width="1.79487" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.5638 11.8206H10.2305" :stroke="disabled ? disabledStateColor : iconColor" stroke-width="1.79487" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.769 14.3335L20.2819 11.8207L17.769 9.30786" :stroke="disabled ? disabledStateColor : iconColor" stroke-width="1.79487" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>